<template>
  <el-dialog
    title="保存信息模板"
    :visible.sync="visible"
    width="500px"
    @close="$emit('update:show', false)"
    @open="opened"
    :append-to-body="inner"
  >
    <!-- <div class="el-form-item el-form--label-left" label="搜索对象" v-if="multiple">
      <label class="el-form-item__label" style="width: 80px;">搜索对象</label>
      <div class="el-form-item__content">
        <el-radio-group v-model="search_table">
          <el-radio label="item">零件</el-radio>
          <el-radio label="device">设备</el-radio>
        </el-radio-group>
      </div>
    </div>-->
    <el-form ref="form" label-width="100px" size="small" label-position="top">
      <el-form-item label="选择旧模板，或输入新模板">
        <el-select
          size="small"
          class="fix-width"
          filterable
          allow-create
          default-first-option
          style="width: 100%"
          placeholder="请选择或输入新模板名称"
          v-model="temp"
          no-match-text="无匹配模板"
          no-data-text="无可用模板，请输入新模板名称后回车"
        >
          <el-option
            v-for="item in temps"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        :loading="submiting"
        @click="submit"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import {
  itemList,
  createItem,
  itemCategoryList,
  ramarkTempList,
  remarkTempList,
  deleteRemarkTemp,
  updateRemarkTemp,
  createRemarkTemp,
} from '../service/getData'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    inner: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    show() {
      this.visible = this.show
    },
  },
  data() {
    return {
      loading: false,
      visible: this.show,
      temp: null,
      temps: [],
      selectionTmp: [],
      submiting: false,
    }
  },
  created() {},
  methods: {
    async requestTemps() {
      let res = await remarkTempList()
      if (res.code == 0) {
        this.temps = res.data.list
      }
    },
    async submit() {
      if (this.temp == null || this.content.length == 0) {
        return
      }

      this.submiting = true
      let type = typeof this.temp
      if (type === 'number') {
        let data = {
          id: this.temp,
          content: this.content,
        }
        let res = await updateRemarkTemp(data)
        if (res.code == 0) {
          this.visible = false
          this.$message.success('保存成功')
        }
        this.submiting = false
      } else if (type === 'string') {
        let data = {
          name: this.temp,
          content: this.content,
        }
        let res = await createRemarkTemp(data)
        if (res.code == 0) {
          this.visible = false
          this.$message.success('保存成功')
        }
        this.submiting = false
      } else {
        this.$message.error('错误的数据类型')
      }
    },
    opened() {
      this.requestTemps()
      this.temp = null
    },
  },
}
</script>